import { StepNavigation } from "../StepNavigation";
import { StepDetails } from "../StepDetails";
import { Typography } from "@mui/material";
import { WizardHelp } from "../WizardHelp";

export const PosMenuStep: React.FC = () => {
  return (
    <>
      <Typography>
        Card Menu displays all possible operations available for cashier on
        selected loyalty account
      </Typography>
      <StepDetails>
        <WizardHelp />
      </StepDetails>
      <StepNavigation />
    </>
  );
};
